export default "__VITE_ASSET__n_xP$v5A__"